import React, { useState } from "react";
import { FileCopyOutlined as FileCopyOutlinedIcon } from "@material-ui/icons";
import { Tooltip, Button, IconButton } from "@material-ui/core";

import translate from "../../../i18n/translate";
import copyToClipboard from "../../../utils/copyToClipboard";

const CLOSE_DELAY = 1500;

const CopyButton = ({
  copy,
  tooltipPlacement = "top",
  withLabel = false,
  ...customProps
}) => {
  const [tooltipIsOpen, setTooltipIsOpen] = useState(false);

  const onClick = () => {
    setTooltipIsOpen(true);
    copyToClipboard(copy);
  };

  const onMouseLeave = () => {
    if (!tooltipIsOpen) return;

    setTimeout(() => {
      setTooltipIsOpen(false);
    }, CLOSE_DELAY);
  };

  return (
    <Tooltip
      arrow
      disableHoverListener
      onMouseLeave={onMouseLeave}
      onOpen={() => setTooltipIsOpen(true)}
      open={tooltipIsOpen}
      placement={tooltipPlacement}
      title={translate("common.copied")}
    >
      {withLabel ? (
        <Button
          color="primary"
          disableElevation
          onClick={onClick}
          size="small"
          startIcon={<FileCopyOutlinedIcon />}
          variant="contained"
          {...customProps}
        >
          {translate("common.copy")}
        </Button>
      ) : (
        <IconButton
          color="primary"
          onClick={onClick}
          size="small"
          {...customProps}
        >
          <FileCopyOutlinedIcon />
        </IconButton>
      )}
    </Tooltip>
  );
};

export default CopyButton;
